import clsx from "clsx";
import NotificationsList from "components/notifications/notificationsList";
import { useEffect, useState } from "react";

export interface IHeaderProps {
    toggleResponsiveMenu: () => void;
}

export default function Header(props: IHeaderProps) {

    const [notificationsAreOpen, setNotificationsAreOpen] = useState(false);
    const [isResponsive, setIsResponsive] = useState(window.innerWidth < 1024);
    const [hasUnreadNotifications, setHasUnreadNotifications] = useState<boolean>(false);
 
    const toggleNotifications = () => {
        setNotificationsAreOpen(!notificationsAreOpen);
    }

    useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 1024px)');

        const handleWindowResize = (e: any) => {
            setIsResponsive(e.matches);
        };

        mediaQuery.addEventListener('change', handleWindowResize);

        return () => {
            mediaQuery.removeEventListener('change', handleWindowResize);
        };
    }, []);

    return (
        <header>
            <div className="container">

                <div className="actions">
                    <button className={clsx('notification', { 'unread': hasUnreadNotifications })} title="Notifications" onClick={() => toggleNotifications()}>
                        <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.0938 16.5027C15.1453 16.2593 17.1236 15.777 19 15.0843C17.4441 13.3573 16.4972 11.071 16.4972 8.56345V7.80457C16.4973 7.78683 16.4974 7.76908 16.4974 7.75131C16.4974 4.16303 13.5885 1.25415 10.0002 1.25415C6.41193 1.25415 3.50306 4.16303 3.50306 7.75131L3.50284 8.56345C3.50284 11.071 2.55585 13.3573 1 15.0843C2.87652 15.777 4.85493 16.2594 6.90663 16.5027M13.0938 16.5027C12.0793 16.623 11.0469 16.6849 10 16.6849C8.95327 16.6849 7.92099 16.623 6.90663 16.5027M13.0938 16.5027C13.1944 16.8161 13.2488 17.1502 13.2488 17.497C13.2488 19.2912 11.7944 20.7456 10.0002 20.7456C8.20607 20.7456 6.75163 19.2912 6.75163 17.497C6.75163 17.1502 6.80598 16.8161 6.90663 16.5027" stroke="#53ADAF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>

                    {isResponsive &&
                        <button className="menu" title="Menu" onClick={() => props.toggleResponsiveMenu()}>
                            <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 1.27271H19M1 6.99998H19M1 12.7273H19" stroke="#53ADAF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>}
                </div>

                <NotificationsList 
                    visible={notificationsAreOpen}
                    onClose={() => setNotificationsAreOpen(false)}
                    onSetHasUnreadNotifications={hasUnread => setHasUnreadNotifications(hasUnread)}
                />
            </div>
        </header>
    )
}